import './App.css';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import About from './components/pages/About';
import FocusAreas from './components/pages/FocusAreas';
import Programs from './components/pages/Programs';
import WhyChooseUs from './components/pages/WhyChooseUs.jsx';
import Impact from './components/pages/Impact.jsx';
import Contact from './components/pages/Contact.jsx';
import Footer from './components/Footer.jsx';

function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900 selection:bg-blue-600 selection:text-white antialiased">
      <Navbar/>
      <main>
        <Home/>
        <About/>
        <FocusAreas/>
        <Programs/>
        <WhyChooseUs/>
        <Impact/>
        <Contact/>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
